import {formatDate} from "@/helpers/utils";

class Promotion {
  id = null;
  code = null;
  type = null;
  // General
  numberOfAvailable = null;
  // Private
  numberOfCode = null;
  codeLength = null;

  constructor(data) {
      this.id = data.id ?? null;
      this.code = data.code ?? null;
      this.type = data.type ?? null;
      this.numberOfAvailable = data.numberOfAvailable ?? null;
      this.numberOfCode = data.numberOfCode ?? null;
      this.codeLength = data.codeLength ?? null;
  }
}

export default Promotion;